// Mock data for the tutoring website

export const courses = [
  {
    id: 1,
    title: "Health and Social Care",
    description: "Comprehensive tutoring covering health policy, care practices, ethical considerations, and practical applications in health and social care settings.",
    icon: "Heart",
    modules: [
      "Health Policy and Legislation",
      "Care Ethics and Values",
      "Person-Centred Care",
      "Safeguarding and Protection",
      "Health Promotion"
    ],
    level: "Higher Education",
    duration: "Flexible scheduling"
  },
  {
    id: 2,
    title: "Counselling",
    description: "Expert guidance in counselling theories, therapeutic approaches, ethical practice, and developing effective counselling skills for professional practice.",
    icon: "Users",
    modules: [
      "Counselling Theories",
      "Therapeutic Relationships",
      "Ethical Practice",
      "CBT and Psychodynamic Approaches",
      "Reflective Practice"
    ],
    level: "Higher Education",
    duration: "Flexible scheduling"
  },
  {
    id: 3,
    title: "Social Sciences",
    description: "In-depth exploration of sociology, psychology, research methods, and critical analysis skills essential for social science studies.",
    icon: "BookOpen",
    modules: [
      "Sociological Perspectives",
      "Research Methods",
      "Social Policy Analysis",
      "Psychology Fundamentals",
      "Critical Thinking"
    ],
    level: "Higher Education",
    duration: "Flexible scheduling"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Single Session",
    price: "45",
    period: "per hour",
    features: [
      "One-to-one online tutoring",
      "Flexible scheduling",
      "Subject-specific support",
      "Session notes provided",
      "Email support"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Monthly Package",
    price: "160",
    period: "per month",
    features: [
      "4 hours of tutoring",
      "Priority booking",
      "All subject areas",
      "Assignment feedback",
      "Email & WhatsApp support",
      "Resource materials included"
    ],
    popular: true,
    savings: "Save £20"
  },
  {
    id: 3,
    name: "Term Package",
    price: "420",
    period: "per term",
    features: [
      "12 hours of tutoring",
      "Flexible session allocation",
      "All subject areas",
      "Essay & assignment review",
      "Priority support",
      "Comprehensive resources",
      "Progress tracking"
    ],
    popular: false,
    savings: "Save £80"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    course: "Health and Social Care, Level 5",
    text: "The tutoring sessions were invaluable for my diploma. The explanations were clear, practical examples helped me understand complex policies, and I felt fully supported throughout.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150"
  },
  {
    id: 2,
    name: "James Patterson",
    course: "Counselling Level 4",
    text: "Excellent support with counselling theories and reflective practice. Darlington's real-world experience and evidence-based approach made all the difference in understanding therapeutic concepts.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150"
  },
  {
    id: 3,
    name: "Aisha Rahman",
    course: "Social Sciences Degree",
    text: "Outstanding help with research methods and data analysis. My grades improved significantly, and I gained confidence in critical analysis. The differentiation approach really helped. Highly recommend!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150"
  },
  {
    id: 4,
    name: "Michael Chen",
    course: "Health and Social Care Foundation",
    text: "Patient, knowledgeable, and always available to help. The trauma-aware and constructivist teaching approaches worked perfectly for my learning style. Best investment in my education.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What qualifications do you have?",
    answer: "I hold an MSc in Data Analytics, PGCE, BSc in Health and Social Care, BSc (Ed) in Geography, Diploma in Health and Social Care Level 3, and I'm a Microsoft Certified Professional. I have over 10 years of experience teaching at higher education level in both the UK and overseas."
  },
  {
    id: 2,
    question: "How do online sessions work?",
    answer: "Sessions are conducted via Zoom or Microsoft Teams. You'll receive a meeting link before your scheduled session. All you need is a stable internet connection and a device with a camera and microphone. Sessions are interactive with screen sharing for materials and resources."
  },
  {
    id: 3,
    question: "Can you help with assignments and essays?",
    answer: "Yes! I provide guidance on structuring assignments, developing arguments, proper referencing (Harvard, APA), and critical analysis. I'll review drafts and provide detailed feedback. Please note: I offer guidance and support, not completion of work for you."
  },
  {
    id: 4,
    question: "What levels do you teach?",
    answer: "I specialize in higher education levels including Foundation degrees, HNDs, undergraduate degrees (Levels 4-6), and postgraduate studies. I'm experienced with various awarding bodies including Pearson, CACHE, Open University, and university programmes."
  },
  {
    id: 5,
    question: "How quickly can I book a session?",
    answer: "I offer flexible scheduling, including evenings and weekends. Subject to availability, you can often book a session within 24-48 hours. Monthly package holders receive priority booking."
  },
  {
    id: 6,
    question: "What if I need to cancel or reschedule?",
    answer: "You can cancel or reschedule up to 24 hours before your session at no charge. Cancellations with less than 24 hours notice will be charged at 50%. Package hours remain valid and can be rescheduled."
  },
  {
    id: 7,
    question: "Do you provide resources and materials?",
    answer: "Yes! All students receive session notes, relevant reading materials, practice questions, and assignment templates. Monthly and term package students get access to my comprehensive resource library."
  },
  {
    id: 8,
    question: "Is there a free consultation?",
    answer: "Absolutely! I offer a free 15-minute consultation where we can discuss your needs, goals, and how I can best support your learning journey. No obligation - just a chance to chat and see if we're a good fit."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Understanding Person-Centred Care in Practice",
    excerpt: "Exploring the principles and practical application of person-centred approaches in health and social care settings...",
    date: "2024-01-15",
    category: "Health & Social Care",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=400"
  },
  {
    id: 2,
    title: "Top 5 Study Tips for Counselling Students",
    excerpt: "Effective strategies for managing your counselling studies, from reflective practice to exam preparation...",
    date: "2024-01-10",
    category: "Counselling",
    readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=400"
  },
  {
    id: 3,
    title: "Research Methods Made Simple",
    excerpt: "A beginner's guide to understanding qualitative and quantitative research approaches in social sciences...",
    date: "2024-01-05",
    category: "Social Sciences",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1532619675605-1ede6c2ed2b0?w=400"
  }
];

export const tutorProfile = {
  name: "Darlington Idahosa",
  title: "Higher Education Lecturer",
  bio: "With over 10 years of teaching experience in the UK and overseas, I provide personalized online tutoring that helps students achieve their academic goals. My approach combines constructivist methodology, evidence-based pedagogy, circumstantial curriculum, and trauma-aware approaches with differentiation strategies to ensure every student succeeds.",
  qualifications: [
    "MSc Data Analytics",
    "PGCE (Post Compulsory Education)",
    "BSc Health and Social Care",
    "BSc (Ed) Geography",
    "Diploma Health and Social Care Level 3",
    "Microsoft Certified Professional (2006)"
  ],
  experience: [
    "10+ years teaching in higher education",
    "UK and overseas teaching experience",
    "Specialist in constructivist learning approaches",
    "Expert in evidence-based pedagogy and trauma-aware teaching"
  ],
  image: "https://customer-assets.emergentagent.com/job_tutor-connect-93/artifacts/jqmzkydu_IMG_20260403_152141.jpg"
};
